import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ExtendDirection } from '@/modules/common/types/extend-direction';
import { invalidateProjectQueries } from '@/modules/common/utils/query-invalidation';

import { deleteProjectChange } from '../api/projects.api';
import { ProjectChangeType } from '../types/project-changes';

interface DeleteProjectChangeParams {
  projectId: number;
  section: ProjectChangeType;
  effectiveStartDate: string;
  extendDirection: ExtendDirection;
}

/**
 * Hook for deleting a project change with conflict resolution
 * Invalidates project queries on success to refresh all project-related screens
 */
export const useDeleteProjectChange = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: DeleteProjectChangeParams) => deleteProjectChange(params),
    onSuccess: async () => {
      await invalidateProjectQueries(queryClient);
    },
  });
};
